import type { CellRendererContext } from "echart-table-library";

/**
 * Business callback: pill badge for basic information statuses
 * (imported table-config.json domain). Business code — belongs to the
 * app, never the library (D4).
 */
const TONES: Record<string, string> = {
  active: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  leave: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  retired: "bg-slate-500/15 text-slate-600 dark:text-slate-400",
};

export function renderBasicInformationStatusCell({
  value,
}: CellRendererContext): HTMLElement {
  const status = String(value ?? "");
  const span = document.createElement("span");
  span.textContent = status.toUpperCase();
  span.className = `inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
    TONES[status.toLowerCase()] ?? "bg-muted text-muted-foreground"
  }`;
  return span;
}
